import styled, { css, keyframes } from 'styled-components';

/* ── paleta do design system ── */
const TEAL = 'var(--teal)';
const TEAL_LIGHT = 'var(--teal-light)';
const CORAL = 'var(--coral)';
const RED_SOFT = 'rgba(207, 58, 58, 0.2)';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.section`

  @media (min-width: 769px) {
    display: none;
  }
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh; /* altura visível real no celular (desconta a barra do navegador) */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
  padding: 72px 22px calc(40px + env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
  overflow-y: auto;
  overscroll-behavior: contain;
  z-index: 1000;

  /* nenhum item encolhe: se não couber, o menu rola */
  > * { flex-shrink: 0; }

  /* fundo no tom do design system, com leve profundidade */
  background:
    radial-gradient(900px 300px at 50% -80px, rgba(224, 122, 95, 0.12) 0%, transparent 70%),
    linear-gradient(180deg, ${TEAL} 0%, #00313c 100%);

  opacity: 0;
  pointer-events: none;
  transform: translateY(40px);
  transition: opacity 0.35s ease, transform 0.35s ease;

  /* botão de fechar */
  > svg {
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: ${CORAL};
    background: rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 6px;
    box-sizing: content-box;
    transform: rotate(45deg);
    transition: transform 0.6s ease, background 0.2s ease;
    cursor: pointer;
    &:hover { background: rgba(255, 255, 255, 0.16); }
  }

  nav {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    max-width: 360px;
    gap: 10px;
    transform: scale(0.96);
    transition: transform 0.5s ease;

    a {
      color: #eef4f6;
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
      text-align: center;
      padding: 14px 18px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.06);
      border: 1px solid rgba(255, 255, 255, 0.1);
      transition: background 0.2s ease, color 0.2s ease, transform 0.12s ease, border-color 0.2s ease;
      animation: ${fadeUp} 0.35s ease backwards;

      &:hover, &:active {
        color: #ffffff;
        background: rgba(255, 255, 255, 0.12);
        transform: translateY(-1px);
      }
    }

    a:nth-child(1) { animation-delay: 0.04s; }
    a:nth-child(2) { animation-delay: 0.08s; }
    a:nth-child(3) { animation-delay: 0.12s; }
    a:nth-child(4) { animation-delay: 0.16s; }
    a:nth-child(5) { animation-delay: 0.20s; }
    a:nth-child(6) { animation-delay: 0.24s; }

    .nav__link.active {
      color: #ffffff;
      font-weight: 700;
      background: rgba(224, 122, 95, 0.22);
      border-color: rgba(224, 122, 95, 0.5);
    }
  }

  ${({ isVisible }) =>
    isVisible &&
    css`
      opacity: 1;
      pointer-events: auto;
      transform: translateY(0px);
      > svg { transform: rotate(0deg); }
      nav { transform: scale(1); }
    `}
`;

/* ── cartão do usuário ── */
export const Emp = styled.div`
  width: 100%;
  max-width: 360px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 16px;
  padding: 18px 16px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  animation: ${fadeUp} 0.35s ease;

  /* indicador "Perfil" (svg + p ficam no fim do cartão) */
  > svg {
    color: ${CORAL};
    font-size: 16px;
    margin-top: -4px;
  }
  > p {
    margin: 0;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: ${CORAL};
  }
`;

export const EmployeeInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Pro = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

/* avatar de iniciais */
export const Avatar = styled.div`
  width: 52px;
  height: 52px;
  min-width: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, ${TEAL_LIGHT} 0%, ${CORAL} 130%);
  border: 2px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  font-weight: 800;
  color: #fff;
  text-transform: uppercase;
`;

export const ProfilePhoto = styled.div`
  width: 52px;
  height: 52px;
  background-color: var(--line);
  border-radius: 50%;
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  cursor: pointer;
`;

export const Name = styled.span`
  display: block;
  margin-bottom: 2px;
  font-size: 17px;
  font-weight: 800;
  color: #ffffff;
  word-break: break-word;
`;

export const Span = styled.span`
  display: inline-block;
  font-size: 12.5px;
  font-weight: 600;
  color: #b9cad0;
  line-height: 1.4;
`;

export const DivButtomEdit = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  flex-wrap: wrap;
`;

export const Btt02 = styled.button`
  flex: 1;
  min-width: 120px;
  color: #eef4f6;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  padding: 11px 18px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.12s ease;

  &:hover {
    background: ${RED_SOFT};
    border-color: rgba(207, 58, 58, 0.45);
    color: #ffd9d4;
    transform: translateY(-1px);
  }
`;